import React, { useEffect } from 'react';
import queryString from 'query-string';
import { renderRoutes } from 'react-router-config';
import { convertDateToParam } from 'app/helpers/actionsHelpers';
import { TabBar } from 'app/components/tab/TabBar';
import { useLocation, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSelectedDistrict } from 'app/actions/sessionActions';
import StickyMobileBannerAdSlot from 'app/components/ads/StickyMobileBannerAdSlot';
import { ErrorHandler } from 'app/components/error/ErrorHandler';
import useDistrictUrls from 'app/hooks/useDistrictUrls';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
const getDateFromParams = params => {
  if (!params.date) {
    return convertDateToParam();
  }
  if (typeof params.date !== 'string') {
    return convertDateToParam();
  }
  if (isNaN(Date.parse(params.date))) {
    return convertDateToParam();
  }
  return params.date;
};
const MatchCalendarPage = _ref => {
  let {
    route
  } = _ref;
  const location = useLocation();
  const params = queryString.parse(location.search);
  let date = getDateFromParams(params);
  const {
    slug
  } = useSelector(reduxSelectDistrict);
  const dispatch = useDispatch();
  const {
    districtSlug,
    categories
  } = useParams();
  const {
    districtMatchesUrl
  } = useDistrictUrls(slug);
  useEffect(() => {
    // set header on back navigation
    dispatch(fetchSelectedDistrict(districtSlug, 'Spiele', location.pathname));
  }, []);
  const TabNames = [{
    name: 'Alle Spiele',
    url: districtMatchesUrl,
    hasSubUrl: true
  }, {
    name: 'Meine Spiele',
    url: '/my/matches'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabBar, {
    tabs: TabNames,
    replace: true,
    children: null,
    disableHeaderCollapsing: false,
    withBg: false,
    "data-sentry-element": "TabBar",
    "data-sentry-source-file": "MatchCalendarPage.tsx"
  }), /*#__PURE__*/React.createElement(ErrorHandler, {
    subroute: true,
    "data-sentry-element": "ErrorHandler",
    "data-sentry-source-file": "MatchCalendarPage.tsx"
  }, renderRoutes(route.routes, {
    date,
    filters: categories
  })), /*#__PURE__*/React.createElement(StickyMobileBannerAdSlot, {
    notOnNative: true,
    "data-sentry-element": "StickyMobileBannerAdSlot",
    "data-sentry-source-file": "MatchCalendarPage.tsx"
  }));
};
export default MatchCalendarPage;